<template>
  <v-container>
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="5">
        <v-card>
          <v-card-title>
            <v-row class="ma-2" justify="center">
              <h1>{{ $t("configure") }}</h1>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-select v-model="deviceModeSelect" :items="deviceMode" color="primary" value :label="$t('deviceMode')" class="mx-2" required></v-select>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  ref="address"
                  v-model="pinUnlockPassword"
                  :label="$t('pinUnlock')"
                  :type="'password'"
                  @change="pinUnlockPasswordWasChanged = true"
                  ma-0
                  pa-0
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-checkbox v-model="TerminalModeActive" :label="$t('terminalMode')" color="primary" class="mx-1"></v-checkbox>

              <v-text-field
                v-if="TerminalModeActive"
                class="pl-4"
                ref="address"
                style="max-width: 100px"
                v-model="seconds"
                :label="$t('timeoutSeconds')"
                :type="'number'"
                :max="180"
                ma-0
                pa-0
              ></v-text-field>
            </v-row>
            <v-row justify="center" align="center">
              <v-btn color="primary" class="font-weight-medium mb-2" @click="save()">{{ $t("save") }}</v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import bcrypt from "bcryptjs";

export default {
  name: "Start",
  route: "Start",
  data: () => ({
    // start.vue
    CssFontSize: ["body-2"],
    windowWidth: $(window).width(),

    logo: "",
    admin: "",
    deviceModeSelect: "",
    TerminalModeActive: false,
    apiRoot: window.location.origin + "/api/",
    firstRun: "",
    localTerminalMode: "",
    localDeviceMode: "",
    pinUnlockPassword: "",
    pinUnlockPasswordWasChanged: false,
    seconds: 15,

    //=AlertHandler==========================
    showAlertDialog: false,
    loaderOverlay: false
  }),
  created() {
    this.initialize();
  },
  computed: {
    deviceMode: function () {
      return [
        {
          value: "UserPassword",
          text: `${this.$t("username")} + ${this.$t("password")}`
        },
        {
          value: "UserPasswordPin",
          text: `${this.$t("username")} + ${this.$t("password")} ${this.$t("or")} Pin`
        },
        { value: "Pin", text: "Pin" },
        { value: "UserPasswordRFID", text: `${this.$t("username")} + ${this.$t("password")} ${this.$t("or")} RFID` },
        { value: "RFID", text: "RFID" }
      ];
    }
  },
  watch: {
    seconds: function (val) {
      if (val > 180) this.seconds = 180;
    }
  },
  methods: {
    initialize() {
      this.firstRun = this.$store.getters["settings/firstRun"];
      this.firstRun = this.firstRun == "true";
      this.localTerminalMode = this.$store.getters["settings/terminalMode"];
      this.localDeviceMode = this.$store.getters["settings/deviceMode"];
      this.seconds = this.$store.getters["settings/timeoutTimer"] != undefined ? this.$store.getters["settings/timeoutTimer"] / 1000 : 15;

      this.pinUnlockPassword = localStorage.getItem("password");
      if (this.firstRun == null) {
        localStorage.setItem("firstRun", true);
        this.firstRun = localStorage.getItem("firstRun");
      } else if (this.firstRun) {
        // Setzt beim ersten Programmlauf Login-Pssword-Pin mode
        this.deviceModeSelect = this.deviceMode[2];
        this.TerminalModeActive = false;
        this.$store.dispatch("language/setLanguage", "de");
        this.save();
      } else {
        if (this.firstRun == "false" && this.localTerminalMode != null && this.localDeviceMode != null) {
          if (this.localDeviceMode == "UserPassword" || this.localDeviceMode == "UserPasswordPin" || this.localDeviceMode == "Pin") {
          }
          // this.$router.push("Login");
          else if (this.localDeviceMode == "RFID") {
          }
          // this.$router.push("Login_RFID");
        }
      }
      if (this.localTerminalMode != null) {
        if (this.localTerminalMode == "true") this.TerminalModeActive = true;
        else this.TerminalModeActive = false;
      }

      if (this.localDeviceMode != null) {
        //var x = document.getElementById("deviceMode")
        this.deviceModeSelect = this.localDeviceMode;
      }
    },
    save() {
      if (this.deviceModeSelect == "") {
        return this.$eventHub.$emit("showError", this.$t("chooseSettings"));
      }
      let settings = {
        deviceMode: this.deviceModeSelect,
        terminalMode: this.TerminalModeActive.toString(),
        timeoutTimer: this.TerminalModeActive ? this.seconds * 1000 : 15000,
        firstRun: false
      };
      this.loaderOverlay = true;
      this.$store.dispatch("settings/setSettings", settings).then(() => {
        this.$router.push({ name: "Login", params: { refresh: "true" } });
      });
      if (this.pinUnlockPasswordWasChanged)
        bcrypt.hash(this.pinUnlockPassword, 10, function (err, hash) {
          if (err) {
            console.error("Fehler beim Hashen:", err);
          } else {
            localStorage.setItem("password", hash);
          }
        });

      this.loaderOverlay = false;
    }
  }
};
//@ sourceURL=start.js
</script>
